module.exports = __webpack_public_path__ + "static/media/cover-mould-in-the-claims-environment.66c2a611.jpg";